/* eslint-disable */
/*
====================================================
THIS IS AN AUTOGENERATED FILE
DO NOT EDIT.
Update with `npm run graphql-codegen`
====================================================
*/
import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreatePatientKnowledgeBasedAccessMutationVariables = Types.Exact<{
  input: Types.CreatePatientKnowledgeBasedAccessInput;
}>;


export type CreatePatientKnowledgeBasedAccessMutation = { __typename?: 'Mutation', createPatientKnowledgeBasedAccess?: { __typename?: 'CreatePatientKnowledgeBasedAccessPayload', success: boolean, errors?: any | null } | null };


export const CreatePatientKnowledgeBasedAccessDocument = gql`
    mutation CreatePatientKnowledgeBasedAccess($input: CreatePatientKnowledgeBasedAccessInput!) {
  createPatientKnowledgeBasedAccess(input: $input) {
    success
    errors
  }
}
    `;
export type CreatePatientKnowledgeBasedAccessMutationFn = Apollo.MutationFunction<CreatePatientKnowledgeBasedAccessMutation, CreatePatientKnowledgeBasedAccessMutationVariables>;

/**
 * __useCreatePatientKnowledgeBasedAccessMutation__
 *
 * To run a mutation, you first call `useCreatePatientKnowledgeBasedAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientKnowledgeBasedAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientKnowledgeBasedAccess, { data, loading, error }] = useCreatePatientKnowledgeBasedAccessMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientKnowledgeBasedAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientKnowledgeBasedAccessMutation, CreatePatientKnowledgeBasedAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientKnowledgeBasedAccessMutation, CreatePatientKnowledgeBasedAccessMutationVariables>(CreatePatientKnowledgeBasedAccessDocument, options);
      }
export type CreatePatientKnowledgeBasedAccessMutationHookResult = ReturnType<typeof useCreatePatientKnowledgeBasedAccessMutation>;
export type CreatePatientKnowledgeBasedAccessMutationResult = Apollo.MutationResult<CreatePatientKnowledgeBasedAccessMutation>;
export type CreatePatientKnowledgeBasedAccessMutationOptions = Apollo.BaseMutationOptions<CreatePatientKnowledgeBasedAccessMutation, CreatePatientKnowledgeBasedAccessMutationVariables>;
